import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-close-icon',
  templateUrl: './close-icon.component.html',
  styleUrls: ['./close-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CloseIconComponent {}
